import React, { useEffect, useState } from 'react'
import { getHomedata } from '../../api'
import './Hometwo.css'
import TopNav from './Navlist/Navlist'
import Hearde from './Hearde/Hearde'
import { insert_adv, remove_adv } from '../../method/addadv'
import Share from './Share/Share'
import Footer from './Footer/Footer'
import { iframeLoad } from '../../method/analytics'

export default function Hometwo() {
  const [dataArray, setDataArray] = useState({
    cate: [],
    hotgame: [],
    newgame: [],
    populgame: [],
  })
  /* 获取首页数据 */
  const getHome = () => {
    getHomedata().then(res => {
      // console.log(res);
      setDataArray({
        cate: res.data.category,
        hotgame: res.data.hotgames,
        newgame: res.data.newgames,
        populgame: res.data.populargames,
      })
    })
  }

  // 跳转详情
  /* const goDetails = (para) => {
        window.location = "/page/details?gid=" + para
    } */

  /* 左上角导航控制 */
  const [flag, setFlag] = useState(false)
  const top_list = () => {
    setFlag(!flag)
  }
  // 判断view是否可以滚动
  flag ? (document.getElementsByTagName('body')[0].style.overflow = 'hidden') : (document.getElementsByTagName('body')[0].style.overflow = 'auto')

  const setflag = () => {
    setFlag(false)
  }
  /* 搜索栏 */
  const [searflag, setSearchflag] = useState(false)
  const setsear = () => {
    setSearchflag(true)
  }
  /* 关闭搜索栏 */
  const setSearch = () => {
    setSearchflag(false)
  }

  /* 分享控制 */
  const [share, setShare] = useState(false)
  const setshare = () => {
    share ? setShare(false) : setShare(true)
  }

  /* const addIframe = () => {
        var ifr = document.createElement('iframe');
        ifr.src = "https://opyaon.fun/";
        document.getElementById('adv_1').appendChild(ifr);
    }
    const addIframe2 = () => {
        var ifr = document.createElement('iframe');
        ifr.src = "https://opyaon.fun/";
        document.getElementById('adv_2').appendChild(ifr);
    } */

  useEffect(() => {
    getHome()

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [])

  return (
    <div className="home_t">
      {/* head */}
      <Hearde top_list={top_list} setsear={setsear} searflag={searflag} setSearch={setSearch} setshare={setshare}></Hearde>

      <TopNav flag={flag} setflag={setflag} gamecata={dataArray.cate} setshare={setshare}></TopNav>
      <Share flag={share} setshare={setshare}></Share>

      {/* section */}
      <section className="main_section" onClick={setflag}>
        {/* 广告一 *************************** */}
        <div className="adv_box">
          <p>advertisement</p>
          <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
        </div>

        <ul>
          {/* popugame */}
          <li>
            {dataArray.populgame?.map(item => (
              <div key={item.gid} className="section_content">
                <a href={'/page/details?gid=' + item.gid} className="dis_a">
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <h4>{item.name}</h4>
                  <div className="play_number">
                    <span> {item.count / 1000}k+</span> <span className="play_btn">PLAYS</span>
                  </div>
                </a>
              </div>
            ))}
          </li>

          {/* hotgame */}
          <li>
            <h1>Hot Games</h1>
            <div className="game_banner">
              <div className="banner_box">
                {dataArray.hotgame?.map(item => (
                  <div key={item.gid} className="section_content">
                    <a href={'/page/details?gid=' + item.gid} className="dis_a">
                      <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </li>

          {/* 广告二 *************************** */}
          <div className="adv_box">
            <p>advertisement</p>
            <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
          </div>

          {/* newgame */}
          <li>
            <h1>New Games</h1>
            {dataArray.newgame?.map(item => (
              <div key={item.gid} className="newgame_content">
                <a href={'/page/details?gid=' + item.gid} className="dis_a">
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <div className="new_con">
                    <h4>{item.name}</h4>
                    <p className="gametype">{item.type}</p>
                    <p className="playnum">{item.count / 1000}k+</p>
                  </div>
                  <div className="play">PLAY GAME</div>
                </a>
              </div>
            ))}
          </li>
        </ul>
      </section>

      {/* foot */}
      <Footer></Footer>
    </div>
  )
}
